import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

export default {
  name: 'VehicleRow',
  props: ['vehicle'],
  data() {
    return {
      open: false,
      showFields: [
        'licence',
        'brand',
        'model',
        'euroclass',
        'vehicleclass',
        'vehicletype',
        'vin',
        'color',
        'typicalusage'
      ]
    }
  },
  computed: {
    vehicleIdentifier() {
      const vehicle = this.vehicle
      let identifier
      if (vehicle.vehicle.make && vehicle.vehicle.trade_name) identifier = `${vehicle.vehicle.make} ${vehicle.vehicle.trade_name}`
      else if (vehicle.brand && vehicle.model) identifier = `${vehicle.brand} ${vehicle.model}`
      else identifier = 'Unidentified vehicle'
      return identifier
    }
  },
  components: {
    FontAwesomeIcon
  },
  methods: {
    openRow(bool) {
      this.$data.open = bool
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/VehicleRow/script.js